module.exports = __webpack_public_path__ + "img/img6.27e5122c.png";